import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { FastField, Field, Formik, useFormikContext } from "formik";
import { shallowEqual, useSelector } from "react-redux";
import { formatNumber, numberWithCommas, sendRequestDotNet } from "../../../../../../../_utils/Axios";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Radio } from "@material-ui/core";
import * as Yup from "yup";
import { useIntl } from "react-intl";
import CustomField from "../CustomField";
import { useFormikWizard } from "formik-wizard";

export function BasicInfo({ }) {
  // const applyFilter = (values) => {
  // };

  const formRef = useRef();
  const intl = useIntl();
  const { prefixes, positions, priceRanges, governorates, minMaxPrice } = useSelector(
    (state) => state.profileSlice,
    shallowEqual
  );
  // console.log(formRef)

  const { values, submitForm } = useFormikContext();

  const SearchSchema = Yup.object().shape({
    idPosition: Yup.string().required(
      intl.formatMessage({
        id: "AUTH.VALIDATION.REQUIRED_FIELD",
      })
    ),

    upper: Yup.string()
      .test(
        'validate-upper',
        `${intl.formatMessage({ id: 'validation.MinMaxValid' })}`,
        // `${intl.formatMessage({ id: 'validation.MustMoreBetween' })} 
        // ${minMaxPrice && formatNumber(minMaxPrice?.minPrice)} 
        // ${intl.formatMessage({ id: 'validation.and' })} 
        // ${minMaxPrice && formatNumber(minMaxPrice?.maxPrice)}`,
        function (value) {
          if (value === "" || value === undefined) {
            return true;
          } else {
            let inputValue = value.replace(/,/g, '');
            let fullValue = inputValue;
            if (inputValue.endsWith("K")) {
              fullValue = parseFloat(inputValue.replace("K", "")) * 1000; // Convert 'K' to number
            } else if (inputValue.endsWith("M")) {
              fullValue = parseFloat(inputValue.replace("M", "")) * 1000000; // Convert 'M' to number
            }
            // console.log(inputValue)
            const { pattern, lower } = this.parent;
            // console.log(lower)
            let inputValueLower = lower.replace(/,/g, '');
            let fullValueLower = fullValue;
            if (inputValue.endsWith("K")) {
              fullValueLower = parseFloat(inputValueLower.replace("K", "")) * 1000; // Convert 'K' to number
            } else if (inputValueLower.endsWith("M")) {
              fullValueLower = parseFloat(inputValueLower.replace("M", "")) * 1000000; // Convert 'M' to number
            }
            const vl = parseInt(fullValueLower); // Safe parse of upper value
            const lowerVl = parseInt(fullValueLower); // Safe parse of lower value

            if (isNaN(vl)) {
              return false;
            }

            if (pattern === undefined) {
              if (vl < minMaxPrice?.minPrice || vl > minMaxPrice?.maxPrice) {
                return false;
              }

              if (!isNaN(lowerVl) && vl < lowerVl) {
                return false;
              }
            }
          }
          return true;
        }
      ),

    lower: Yup.string()
      .test(
        'validate-lower',
        `${intl.formatMessage({ id: 'validation.MinMaxValid' })}`,
        // `${intl.formatMessage({ id: 'validation.MustBetween' })} ${minMaxPrice && formatNumber(minMaxPrice?.minPrice)} ${intl.formatMessage({ id: 'validation.and' })} ${minMaxPrice && formatNumber(minMaxPrice?.maxPrice)}`,
        function (value) {
          if (value === "" || value === undefined) {
            return true;
          } else {

            let inputValue = value.replace(/,/g, '');
            let fullValue = inputValue;
            if (inputValue.endsWith("K")) {
              fullValue = parseFloat(inputValue.replace("K", "")) * 1000; // Convert 'K' to number
            } else if (inputValue.endsWith("M")) {
              fullValue = parseFloat(inputValue.replace("M", "")) * 1000000; // Convert 'M' to number
            }
            // console.log(fullValue)
            const formattedValue = Number(fullValue).toLocaleString();
            // console.log(formattedValue)

            const { pattern, upper } = this.parent;
            // console.log(upper)
            let inputValueUpper = upper.replace(/,/g, '');
            let fullValueUpper = fullValue;
            if (inputValueUpper.endsWith("K")) {
              fullValueUpper = parseFloat(inputValueUpper.replace("K", "")) * 1000; // Convert 'K' to number
            } else if (inputValueUpper.endsWith("M")) {
              fullValueUpper = parseFloat(inputValueUpper.replace("M", "")) * 1000000; // Convert 'M' to number
            }
            //
            // console.log(fullValueUpper)
            const vl = parseInt(fullValue); // Safe parse of lower value
            const upperVl = parseInt(fullValueUpper); // Safe parse of upper value


            if (isNaN(vl)) {
              return false;
            }

            if (pattern === undefined) {
              if (vl < minMaxPrice.minPrice || vl > minMaxPrice.maxPrice) {
                return false;
              }

              if (!isNaN(upperVl) && vl > upperVl) {
                return false;
              }
            }
          }
          // console.log(value)
          return true;
        }
      ),

    pattern: Yup.string()
      .test(
        'validate-pattern',
        intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' }),
        function (value) {
          const { upper, lower } = this.parent;
          if ((upper === undefined || upper === null) && (lower === undefined || lower === null)) {
            return value?.trim() !== '';
          }
          return true;
        }
      )
      .max(7, intl.formatMessage({ id: 'AUTH.VALIDATION.DID.MAX_LENGTH_FIELD' })),

    // prefix: Yup.string().required(
    //   intl.formatMessage({
    //     id: "AUTH.VALIDATION.REQUIRED_FIELD",
    //   })
    // ),
    
  });

  const [list, setList] = useState([]);
  const [selectedValue, setSelectedValue] = useState();
  const [loading, setLoading] = useState(false);
  const [isSuggested, setIsSuggested] = useState(false);
  const context = useFormikWizard();

  useEffect(() => {
   // prefixes && formRef.current.setFieldValue("prefix", prefixes[0].prefix)
    positions && formRef.current.setFieldValue("idPosition", positions[0].idParam)
  }, [prefixes, positions]);

  return (
    <>
      <Card>
        <Card.Body>
          <Card.Title>
            {intl.formatMessage({
              id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.SEARCH_NBR",
            })}
          </Card.Title>
          <Formik
            innerRef={formRef}
            enableReinitialize={false}
            validationSchema={SearchSchema}
            initialValues={{
              idPosition: "",
              pattern: "",
              prefix: "",//prefixes && prefixes[0].prefix,
              priceRange: {},
            }}
            onSubmit={(values) => {
              setLoading(true);
              let val = values;
              let priceRangeLow = values.lower
              let priceRangeUpper = values.upper
              if (values.lower !== undefined && values.upper !== undefined) {
                if (values.lower.endsWith("K")) {
                  priceRangeLow = parseFloat(priceRangeLow.replace("K", "").split(".")[0]) * 1000; // Convert 'K' to number
                } else if (values.lower.endsWith("M")) {
                  priceRangeLow = parseFloat(priceRangeLow.replace("M", "").split(".")[0]) * 1000000; // Convert 'M' to number
                }
                if (values.upper.endsWith("K")) {
                  priceRangeUpper = parseFloat(priceRangeUpper.replace("K", "").split(".")[0]) * 1000; // Convert 'K' to number
                } else if (values.upper.endsWith("M")) {
                  priceRangeUpper = parseFloat(priceRangeUpper.replace("M", "").split(".")[0]) * 1000000; // Convert 'M' to number
                }
                let priceRange = {
                  lower: values.lower ? priceRangeLow : 0,
                  upper: values.upper ? priceRangeUpper : 0,
                  // lower: parseInt(values.priceRange.split("-")[0]),
                  // upper: parseInt(values.priceRange.split("-")[1]),
                };


                val.priceRange = priceRange;
                // delete val.lower
                // delete val.upper
              }
              sendRequestDotNet("Number/Search ", val).then((response) => {

                // val.priceRange.lower != 0 && 
                // formRef.current.setFieldValue("lower", numberWithCommas(val.priceRange.lower))
                // formRef.current.setFieldValue("upper", numberWithCommas(val.priceRange.upper))
                setList(response.data.list);
                setIsSuggested(response.data.isSuggested);
                setLoading(false);
              });

              // const handleClickScroll = () => {
              const element = document.getElementById("select");
              if (element) {
                // 👇 Will scroll smoothly to the top of the next section
                element.scrollIntoView({ behavior: "smooth" });
              }
              // };
              // applyFilter(values);
            }}
          >
            {({
              values,
              touched,
              errors,
              isSubmitting,
              handleSubmit,
              handleBlur,
              handleChange,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit} className="form form-label-right">
                <div className="form-group row mb-0 frmkorekserv">

                  {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                  {
                    <div className="col-lg-6">
                      <label className="mt-2">
                        <b>
                          {intl.formatMessage({
                            id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.PREFIX",
                          })}
                        </b>
                      </label>
                      <select
                        className="form-control"
                        name="prefix"
                        placeholder="Filter by prefix"
                        onChange={(e) => {
                          setFieldValue("prefix", e.target.value);
                          // handleSubmit();
                        }}
                        onBlur={handleBlur}
                        value={values.prefix}
                      >
                        {/* <option value="">
                          {intl.formatMessage({
                            id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.SELECT_PREFIX",
                          })}
                        </option>{" "} */}
                        {/* {prefixes &&
                          prefixes.map((x, i) => (
                            <option key={i} value={x.prefix}>
                              {x.prefix}
                            </option>
                          ))} */}
                          {prefixes && (
                              <>
                                <option value=""> {intl.formatMessage({
                            id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.All",
                          })}</option>
                                {prefixes.map((x, i) => (
                                  <option key={i} value={x.prefix}>
                                    {x.prefix}
                                  </option>
                                ))}
                              </>
                            )}
                      </select>
                      {touched.prefix && errors.prefix ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.prefix}</div>
                        </div>
                      ) : null}
                    </div>
                  }
                  {
                    <div className="col-lg-6">
                      <label className="mt-2">
                        <b>
                          {intl.formatMessage({
                            id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.POSITION",
                          })}
                        </b>
                      </label>
                      <select
                        className="form-control"
                        placeholder="Filter by Type"
                        name="idPosition"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setFieldValue("idPosition", e.target.value);
                          // handleSubmit();
                        }}
                        value={values.idPosition}
                      >
                        {/* <option value="">
                          {intl.formatMessage({
                            id:
                              "KOREK_SERVICES.MY_NBR_MY_CHOICE.SELECT_POSITION",
                          })}
                        </option> */}
                        {positions &&
                          positions.map((x, i) => (
                            <option key={i} value={x.idParam}>
                              {x.value}
                            </option>
                          ))}
                      </select>
                      {touched.idPosition && errors.idPosition ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.idPosition}</div>
                        </div>
                      ) : null}
                    </div>
                  }
                  {
                    <div className="col-lg-6">
                      <Row>
                        <Col className="pl-0 pr-3">
                          <label className="mt-2">
                            <b>
                              {intl.formatMessage({
                                id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.FROM",
                              })}
                            </b>
                          </label>
                          <input
                            // type="number"
                            className="form-control tel-input"
                            name="lower"
                            placeholder={intl.formatMessage({
                              id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.FROM",
                            })}
                            onBlur={(e) => {
                              let sanitizedValue = parseInt(e.target.value.replaceAll(",", ""));
                              if (sanitizedValue == "" || sanitizedValue < minMaxPrice.minPrice) sanitizedValue = minMaxPrice.minPrice;

                              const roundedValue = Math.floor(sanitizedValue / 1000) * 1000; // Round to nearest 1000
                              let formattedValue = roundedValue;

                              if (roundedValue >= 1000000) {
                                if (roundedValue % 1000000 === 0) {
                                  formattedValue = (roundedValue / 1000000).toFixed(0) + "M"; // No decimals if exactly divisible by 1 million
                                } else {
                                  formattedValue = (roundedValue / 1000000).toFixed(1) + "M";
                                }
                              } else if (roundedValue >= 1000) {
                                formattedValue = (roundedValue / 1000).toFixed(0) + "K"; // Format as thousands
                              } else if (isNaN(formattedValue)) {
                                formattedValue = ""
                              }
                              setFieldValue("lower", formattedValue); // Set formatted value
                            }}
                            value={values.lower}
                            onChange={(e) => {
                              const sanitizedValue = e.target.value.replace(/,/g, '');
                              const formattedValue = Number(sanitizedValue).toLocaleString();
                              setFieldValue("lower", formattedValue);
                            }}
                            onClick={(e) => {
                              setFieldValue("lower", "")
                            }}
                          />

                          {touched.lower && errors.lower ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">{errors.lower}</div>
                            </div>
                          ) : null}
                        </Col>
                        <Col className="pr-0 pl-3">
                          <label className="mt-2">
                            <b>
                              {intl.formatMessage({
                                id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.TO",
                              })}
                            </b>
                          </label>
                          <input
                            type="text" // Use 'text' instead of 'number' to allow user input like '3k'
                            className="form-control tel-input"
                            name="upper"
                            placeholder={intl.formatMessage({
                              id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.TO",
                            })}
                            onBlur={(e) => {
                              let sanitizedValue = parseInt(e.target.value.replaceAll(",", ""));
                              if (sanitizedValue > minMaxPrice.maxPrice || sanitizedValue < minMaxPrice.minPrice) {
                                sanitizedValue = minMaxPrice.maxPrice;
                              }

                              const roundedValue = Math.floor(sanitizedValue / 1000) * 1000; // Round to nearest 1000
                              let formattedValue = roundedValue;

                              if (roundedValue >= 1000000) {
                                if (roundedValue % 1000000 === 0) {
                                  formattedValue = (roundedValue / 1000000).toFixed(0) + "M"; // No decimals if exactly divisible by 1 million
                                } else {
                                  formattedValue = (roundedValue / 1000000).toFixed(1) + "M";
                                }
                              } else if (roundedValue >= 1000) {
                                formattedValue = (roundedValue / 1000).toFixed(0) + "K"; // Format as thousands
                              } else if (isNaN(formattedValue)) {
                                formattedValue = ""
                              }

                              setFieldValue("upper", formattedValue); // Set formatted value
                            }}
                            value={values.upper}
                            onChange={(e) => {
                              const sanitizedValue = e.target.value.replace(/,/g, '');
                              const formattedValue = Number(sanitizedValue).toLocaleString();
                              setFieldValue("upper", formattedValue);
                            }}
                            onClick={(e) => {
                              setFieldValue("upper", "")
                            }}
                          />
                          {touched.upper && errors.upper ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">{errors.upper}</div>
                            </div>
                          ) : null}</Col>
                      </Row>
                      {/* <small className="form-text text-muted">
                        <b>
                          {intl.formatMessage({
                            id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.PRICE_RANGE",
                          })}
                        </b>
                      </small>
                      <select
                        className="form-control"
                        placeholder="Filter by Type"
                        name="priceRange"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setFieldValue("priceRange", e.target.value);
                          // handleSubmit();
                        }}
                        value={values.priceRange}
                      >
                        <option value="">
                          {intl.formatMessage({
                            id:
                              "KOREK_SERVICES.MY_NBR_MY_CHOICE.SELECT_PRICE_RANGE",
                          })}
                        </option>
                        {priceRanges &&
                          priceRanges.map((x, i) => (
                            <option key={i} value={x.value}>
                              {x.value}
                            </option>
                          ))}
                      </select>
                      {touched.priceRange && errors.priceRange ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.priceRange}</div>
                        </div>
                      ) : null} */}
                    </div>
                  }
                  <div className="col-lg-6">
                    <label className="mt-2">
                      <b>
                        {intl.formatMessage({
                          id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.DIGITS",
                        })}
                      </b>
                    </label>
                    <input
                      type="number"
                      className="form-control tel-input"
                      name="pattern"
                      placeholder={intl.formatMessage({
                        id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.ENTER_DIGITS",
                      })}
                      onBlur={handleBlur}
                      value={values.pattern}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFieldValue("pattern", value);
                          // handleSubmit();
                        }
                      }}
                    />

                    {touched.pattern && errors.pattern ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{errors.pattern}</div>
                      </div>
                    ) : null}
                  </div>
                  <div className="col-lg-12 pt-5">
                    <Button
                      onClick={() => {

                        handleSubmit();
                        setFieldValue("priceRange", values.priceRange);
                      }}
                      disabled={loading}
                      className="btn btn-warning"
                    >
                      <b>
                        {intl.formatMessage({
                          id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.SEARCH",
                        })}
                      </b>
                      {loading && (
                        <span className="mx-3 spinner spinner-white"></span>
                      )}
                    </Button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </Card.Body>
      </Card>
      <div id="select"></div>
      <Card className="mt-5">
        <Card.Body>
           {isSuggested &&
          <Card.Title >
            <b>No results found. Here are some suggested numbers.</b>
          </Card.Title>}
           <Card.Subtitle className="mb-3">
           <b> {intl.formatMessage({
              id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.SELECT_NBR",
            })}</b>
          </Card.Subtitle>
          <div
            style={{
              overflowY: "auto",
              height: list.length > 0 ? "300px" : "auto",
            }}
          >
            <table className="table table table-head-custom table-vertical-center overflow-hidden">
              <thead>
                <tr>
                  <th>
                    {intl.formatMessage({
                      id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.NBR",
                    })}
                  </th>
                  <th>
                    {intl.formatMessage({
                      id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.PRICE",
                    })}
                  </th>
                  {/* <th>priceFloat</th>
          <th>lineType</th> */}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <SkeletonTheme>
                    <tr>
                      <td>
                        <Skeleton height={30} count={3} />
                      </td>
                      <td>
                        <Skeleton height={30} count={3} />
                      </td>
                      <td>
                        <Skeleton height={30} count={3} />
                      </td>
                      {/* <td>
                  <Skeleton height={20} count={3} />
                </td> */}
                    </tr>
                  </SkeletonTheme>
                ) : list.length > 0 ? (
                  list.map((of) => (
                    <tr
                      className={
                        selectedValue === of.msisdn ? "selected-tr" : ""
                      }
                      key={`id${of.id}`}
                    >
                      <td>{of.msisdn}</td>
                      <td>{of.price}</td>
                      {/* <td>{of.priceFloat}</td> */}
                      {/* <td>{of.lineType}</td> */}
                      <td className="text-right">
                        <Radio
                          checked={selectedValue === of.msisdn}
                          onChange={() => {
                            setSelectedValue(of.msisdn);
                            let newVal = context.values;
                            newVal.basic.msisdn = of.msisdn;
                            newVal.basic.price = of.price;
                            context.setValues(newVal);
                            // setFieldValue("msisdn",of.msisdn)
                          }}
                          value={of.msisdn}
                          name="msisdn"
                          inputProps={{ "aria-label": "A" }}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    {intl.formatMessage({
                      id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.NO_RECORD_AVAI",
                    })}
                  </>
                )}
              </tbody>
            </table>
          </div>
          {/* {selectedValue && ( */}
          <Button disabled={!selectedValue} className="btn btn-warning mt-5" type="submit" style={{
    fontWeight: 'bold',
    fontSize: '1.3rem',
    width: '193px',
    height: '47px',
    margin: '0 auto',
    display: 'block',
  }}>
            <b>
              {intl.formatMessage({
                id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.SUBMIT",
              })}
            </b>
          </Button>
         <br/><br/>
          <p>
            <h5><b>{intl.formatMessage({
                id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.INSTRUCTIONS",
              })}</b></h5>
             <ul style={{
                  paddingLeft: '15px'
                }}>
                <li>{intl.formatMessage({
                id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.SEARCHFN",
                 })}</li>
                <li>{intl.formatMessage({
                id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.CHOOSEN",
                 })}</li>
                <li>{intl.formatMessage({
                id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.FILLINFO",
                 })}</li>
                <li>{intl.formatMessage({
                id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.SELECTNEAREST",
                 })}</li>
                 <li>{intl.formatMessage({
                id: "KOREK_SERVICES.MY_NBR_MY_CHOICE.RESERVE_NBR",
                 })}</li>
              </ul>
          </p>
 
          {/* )} */}
          {/* <input  name="msisdn" />
        <Field
        value={selectedValue}  name="msisdn" id="msisdn"  /> */}
        </Card.Body>
      </Card>
    </>
  );
}
